/**
 * EntityCard — summary card for accounts, merchants, people, etc.
 *
 * Props (from agent render_center_panel tool):
 *   entities: Array<{ id, name, type, details: {key: value} }>
 *   title: string — optional section title
 *   onInteraction: (event) => void — callback for user clicks
 */

import React from 'react';
import styles from './EntityCard.module.css';

function EntityCard({ entities = [], title, onInteraction }) {
  const handleClick = (entity) => {
    if (onInteraction) {
      onInteraction({
        type: 'entity_selected',
        entityId: entity.id,
        entityType: entity.type,
        data: entity,
      });
    }
  };

  return (
    <div className={styles.container}>
      {title && <h3 className={styles.title}>{title}</h3>}
      <div className={styles.grid}>
        {entities.map((entity) => (
          <div
            key={entity.id}
            className={styles.card}
            onClick={() => handleClick(entity)}
          >
            <div className={styles.cardHeader}>
              <span className={styles.cardType}>{entity.type}</span>
              <span className={styles.cardName}>{entity.name}</span>
            </div>
            {entity.details && (
              <div className={styles.cardDetails}>
                {Object.entries(entity.details).map(([key, value]) => (
                  <div key={key} className={styles.detailRow}>
                    <span className={styles.detailKey}>{key}</span>
                    <span className={styles.detailValue}>{String(value)}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      {entities.length === 0 && (
        <div className={styles.empty}>No entities to display</div>
      )}
    </div>
  );
}

export default EntityCard;
